/**
 * Promo-site entry: wire the page behaviors, then embed the LIVE widget (the
 * real apps/widget bundle, served under /vendor/ — see vite.config.ts).
 */
import { initCopy, initNavStuck, initNudge, initReveal, initSubscribe } from './page.js';
import { embedLiveWidget, resolvePromoConfig } from './promo-config.js';

initNavStuck();
initReveal();
initCopy();
initSubscribe();
initNudge();

embedLiveWidget(resolvePromoConfig(location.search));
